import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class RegconRegisterMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.regconRegister.regconRegisterMapperError"));

        Object.setPrototypeOf(this, RegconRegisterMapperError.prototype);
    }
}